'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatHeadGroupStyle = getChatHeadGroupStyle;

var _Constants = require('ui-addon-avatars/Constants');

function getChatHeadGroupStyle(_ref) {
  var mobile = _ref.mobile;

  if (mobile) {
    return {
      flex: '0 0 32px',
      height: _Constants.AVATAR_SIZES.sm,
      width: '100%'
    };
  }

  return {
    height: _Constants.AVATAR_SIZES.md
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/util/getChatHeadGroupStyle.js
// module id = 505
// module chunks = 2 3